import { useState, useEffect, useRef, useCallback } from "react";
import Box from "@mui/material/Box";
import { useNavigate, useLocation } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import debounce from "lodash.debounce";

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const PastWinner = () => {
  const navigate = useNavigate();
  const [leaderboardData, setLeaderboardData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [pageNumber, setPageNumber] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const pageSize = 20;
  const scrollRef = useRef(null);
  const location = useLocation();
  const backURL = sessionStorage.getItem("backURLs") || "";
  useEffect(() => {
    return () => {
      sessionStorage.removeItem("leaderBoardCurrentMobileNumber");
    };
  }, []);

  useEffect(() => {
    getLeaderboardData(pageNumber, searchQuery || "empty");
  }, [pageNumber, searchQuery]);

  const getLeaderboardData = async (page, searchDataItems) => {
    if (loading || !hasMoreData) return;
    setLoading(true);

    try {
      let searchData =
        !searchDataItems || searchDataItems.trim() === ""
          ? "empty"
          : searchDataItems;

      const response = await fetch(
        `${apiBaseURL}/api/IPLContestWatcho/GetPastWinnersDetails?name=${searchData}&pageNumber=${page}&pageSize=${pageSize}`,
        { method: "GET" }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response?.status}`);

      const responseData = await response.json();
      const newResults = responseData?.result || [];
      const fetchedTotalCount = responseData?.totalCount || 0;

      if (page === 1) {
        setLeaderboardData(newResults);
      } else {
        setLeaderboardData((prevData) => [...prevData, ...newResults]);
      }

      if (page === 1) {
        setTotalCount(fetchedTotalCount);
      }

      if (leaderboardData.length + newResults.length >= fetchedTotalCount) {
        setHasMoreData(false);
      }
    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleScroll = useCallback(() => {
    if (!scrollRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      !loading &&
      hasMoreData
    ) {
      setPageNumber((prevPage) => prevPage + 1);
    }
  }, [loading, hasMoreData]);

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    scrollContainer.addEventListener("scroll", handleScroll);
    return () => scrollContainer.removeEventListener("scroll", handleScroll);
  }, [handleScroll]);

  const handleSearch = useCallback(
    debounce((searchDataItems) => {
      setSearchQuery(searchDataItems);
      setPageNumber(1);
      setLeaderboardData([]);
      setHasMoreData(true);
    }, 300),
    []
  );

  const handleBack = () => {
    const path =
      backURL === "IPLContestWatcho"
        ? `/${backURL}`
        : `/IPLContestWatcho?key=${backURL}`;
    navigate(path);
  };

  return (
    <div className="container">
      {!backURL ? (
        ""
      ) : (
        <div className="back my-3">
          <button
            style={{
              backgroundColor: "transparent",
              border: "none",
              cursor: "pointer",
            }}
            onClick={handleBack}
          >
            <i className="fa-solid fa-arrow-left mr-2"></i> Back
          </button>
        </div>
      )}

      <div className="leaderBoardInnerWrapper">
        <h1>Check Past Winners!</h1>
        <div
          className="leaderBoardContainer mt-3"
          style={{
            height: `calc(100vh - 160px)`,
            maxWidth: "90%",
            width: "100%",
          }}
        >
          <div className="searchContainer mb-2" style={{ textAlign: "right" }}>
            <input
              type="text"
              placeholder="Search Name"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>

          {/* Custom Scrollable Container */}
          <div
            className="winner-scroll"
            ref={scrollRef}
            style={{ paddingRight: "6px" }}
            // style={{ height: "500px", overflowY: "auto" }}
          >
            {leaderboardData?.length === 0 && !loading ? (
              <p className="text-center" style={{ width: "100%" }}>
                No winners found.
              </p>
            ) : (
              leaderboardData?.map((item, index) => (
                <div className="grid grid-cols-2 gap-4 mb-2" key={index}>
                  <Card
                    className="p-2 bg-dark border-0 customCard"
                    variant="outlined"
                  >
                    <Box sx={{ whiteSpace: "nowrap", mx: 1 }}>
                      <Typography
                        fontWeight={400}
                        textColor="#ffffff"
                        textTransform="uppercase"
                      >
                        Winning Amount -{" "}
                        <span className="font-weight-bold">
                          ₹ {item?.winningAmt || "N/A"}
                        </span>
                      </Typography>
                      <Typography
                        textTransform="uppercase"
                        fontSize={16}
                        textColor="#ffffff"
                        fontWeight={"600"}
                      >
                        {item?.winnerName || "Unknown"}
                      </Typography>
                      <Typography fontSize={14} textColor="#ffffff">
                        {item?.maskedMobileNo || "N/A"}
                      </Typography>
                    </Box>
                  </Card>
                </div>
              ))
            )}

            {loading && <p>Loading more winners...</p>}
          </div>
        </div>
      </div>
    </div>
  );
};
